import { t } from "@lingui/macro"
import { Chip } from "@mui/material"
import { Info, Warning, Error } from "@mui/icons-material"
import { memo } from "react"

import { AlertLevel, ALERT_LEVELS } from "src/views/alerts/constants"

interface IAlertLevelChipProps {
    level?: AlertLevel | string
}

const getLevelConfig = (level?: AlertLevel | string) => {
    switch (level) {
        case ALERT_LEVELS.INFO:
            return {
                label: t`alerts.level.info`,
                color: "info" as const,
                icon: <Info sx={{ fontSize: "16px !important" }} />,
            }
        case ALERT_LEVELS.WARNING:
            return {
                label: t`alerts.level.warning`,
                color: "warning" as const,
                icon: <Warning sx={{ fontSize: "16px !important" }} />,
            }
        case ALERT_LEVELS.ERROR:
            return {
                label: t`alerts.level.error`,
                color: "error" as const,
                icon: <Error sx={{ fontSize: "16px !important" }} />,
            }
        default:
            return {
                label: t`alerts.level.info`,
                color: "info" as const,
                icon: <Info sx={{ fontSize: "16px !important" }} />,
            }
    }
}

export const AlertLevelChip = memo(({ level }: IAlertLevelChipProps) => {
    const config = getLevelConfig(level)

    return (
        <Chip
            label={config.label}
            color={config.color}
            variant="filled"
            size="small"
            icon={config.icon}
            sx={{
                fontWeight: 500,
                fontSize: "12px",
                height: "24px",
                "& .MuiChip-icon": {
                    marginLeft: "5px",
                    marginRight: "-2px",
                },
            }}
        />
    )
})
